<div class="modal-top">
  <h1>{{ 'sources.sample-data.title' | translate }}</h1>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="bimnodes-table">
  <mee-table [builder]="tableBuilder"></mee-table>
</div>
